import React from "react"
import CareersCard from "../../careers-card"

interface CareerJobListType {
  division: string
  jobTitle: string
  jobUrl: string
  categories: string
  locationName: string
  jobType: string
  experienceLevel: string
  requisitionId: number
}

interface SingleCareerJobType {
  job: CareerJobListType
  job_path: string;
}

const SingleCareerJob = ({ job, job_path }: SingleCareerJobType) => {

  const { jobTitle, locationName, categories, jobType, experienceLevel, requisitionId } = job

  return (
    <a href={`${job_path}?cid=${requisitionId}`} key={requisitionId}>
      <CareersCard
        title={jobTitle}
        location={locationName}
        department={categories.includes(",") ? categories.split(",") : [categories]}
        jobType={jobType ? `${jobType} - ${experienceLevel}` : experienceLevel}
      />
    </a>
  )
}

export default SingleCareerJob